import CwDocPreview from "./index.vue"

export default CwDocPreview